export default __webpack_public_path__ + "static/media/arras04.63864607.jpg";